import { Injectable } from '@angular/core';
import { HttpClientService } from '../http/http-client.service';
import { DataHolder } from '../models/data-holder.model';
import { SupportedLanguage } from '../models/supported-language.model';
import { TranslateCollectorService } from './translate-collector.service';

@Injectable({
    providedIn: 'root',
})
export class RestI18nLoader {

    protected myPriority: number = 1;

    constructor(private myHttpClientService: HttpClientService,
                private myTranslateCollectorService: TranslateCollectorService,
    ) {
    }

    public init(): void {
        this.myHttpClientService.get('root/i18n/supported-locales').subscribe((dataHolder: DataHolder) => {
            const supportedLanguages: SupportedLanguage[] = dataHolder.data as SupportedLanguage[];

            for (const supportedLanguage of supportedLanguages) {
                this.loadTranslations(supportedLanguage.language);
            }
        });
    }

    protected loadTranslations(lang: string): void {
        this.myHttpClientService.get(`root/i18n/resources/${lang}`).subscribe(
            (dataHolder: DataHolder) => {
                const responseAsString: string = JSON.stringify(dataHolder.data[ 0 ]) || '{}';
                this.myTranslateCollectorService.addTranslations(JSON.parse(responseAsString), lang, this.myPriority);
            }, () => {
                this.myTranslateCollectorService.addTranslations({}, lang, this.myPriority);
            });
    }
}
